window.addEventListener('load', function () {
    let shouldLoadVideo = true;

    window.addEventListener('beforeunload', function () {
        shouldLoadVideo = false;
    });

    setTimeout(() => {
        if (!shouldLoadVideo) return;

        const video = document.getElementById('home-video');
        if (!video) return;

        const source = document.createElement('source');
        source.src = '//cdn.svat.org.uk/stour-vale-academy-trust/hero.mp4';
        source.type = 'video/mp4';
        video.appendChild(source);
        video.load();
    }, 3000);
});

jQuery(document).ready(function($) {	

	$('#hero-slider').bxSlider({
		mode: 'fade',
		auto: true,
		nextText: '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L0 12L-5.24537e-07 0L6 6Z" fill="currentcolor"/></svg>',
		prevText: '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.86805e-07 6L6 0L6 12L7.86805e-07 6Z" fill="currentcolor"/></svg>',
		pause: 5000,
		stopAutoOnClick: true,
		onSlideBefore: function ($el, oldIndex, newIndex) {
			const pagerLinks = $('.hero-slider-wrapper .bx-pager-link');

			pagerLinks.each(function (i) {
				if (i < newIndex) {
					$(this).addClass('was-active');
				} else {
					$(this).removeClass('was-active');
				}
			});
		},
	});

	$('#page-slider').bxSlider({
		mode: 'fade',
		auto: true,
		nextText: '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L0 12L-5.24537e-07 0L6 6Z" fill="currentcolor"/></svg>',
		prevText: '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.86805e-07 6L6 0L6 12L7.86805e-07 6Z" fill="currentcolor"/></svg>',
		pause: 5000,
		pager: false
	});

	const windowWidth = $(window).width();
	const $jobsSlider = $('#jobs-slider');
	const jobsSliderWidth = $jobsSlider.closest('.jobs-slider-wrapper').width();
	const jobsSlidePer = Math.max(1, Math.min(Math.floor(windowWidth / 421), 3));
	const jobsSlideGap = 16;
	const jobsSlideWidth = (jobsSliderWidth - (jobsSlideGap * (jobsSlidePer - 1))) / jobsSlidePer;

	const jobsCount = $jobsSlider.find('.jobs-card').length;
	const minSlidesReached = jobsCount > jobsSlidePer;

	$jobsSlider.bxSlider({
		auto: minSlidesReached,
		nextText: '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L0 12L-5.24537e-07 0L6 6Z" fill="currentcolor"/></svg>',
		prevText: '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.86805e-07 6L6 0L6 12L7.86805e-07 6Z" fill="currentcolor"/></svg>',
		pause: 5000,
		pager: minSlidesReached,
		controls: minSlidesReached,
		slideWidth: jobsSlideWidth,
		moveSlides: 1,
		minSlides: jobsSlidePer,
		maxSlides: jobsSlidePer,
		slideMargin: jobsSlideGap,
		stopAutoOnClick: true,
		infiniteLoop: minSlidesReached,
		touchEnabled: false,
		onSlideBefore: function ($el, oldIndex, newIndex) {
			const pagerLinks = $('.jobs-slider-wrapper .bx-pager-link');

			pagerLinks.each(function (i) {
				if (i < newIndex) {
					$(this).addClass('was-active');
				} else {
					$(this).removeClass('was-active');
				}
			});
		},
	});

	$('#card-slider').bxSlider({
		// mode: 'fade',
		auto: true,
		slideMargin: 16,
		nextText: '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L0 12L-5.24537e-07 0L6 6Z" fill="currentcolor"/></svg>',
		prevText: '<svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.86805e-07 6L6 0L6 12L7.86805e-07 6Z" fill="currentcolor"/></svg>',
		pause: 5000,
		stopAutoOnClick: true,
		onSlideBefore: function ($el, oldIndex, newIndex) {
			const pagerLinks = $('.card-slider-wrapper .bx-pager-link');

			pagerLinks.each(function (i) {
				if (i < newIndex) {
					$(this).addClass('was-active');
				} else {
					$(this).removeClass('was-active');
				}
			});
		},
	});

	function openLightbox(content, type = 'img') {
	    // Remove any old instance + old keydown handler
  		$('#lightbox').remove();
  		$(document).off('keydown.lightbox');

	    // Create the lightbox dynamically
	    const $box = $('<div id="lightbox" class="'+ type +'-lightbox"><div class="lightbox-center"><div class="lightbox-inner">' + content + '</div></div></div>').appendTo('body');

	    // Close on background click
	    $box.on('click', function (e) {
	    	if (!$(e.target).closest('.lightbox-inner').length) {
	    		$box.remove();
	   		}
	    });

	    // Close on ESC
	    $(document).on('keydown.lightbox', function (ev) {
	      if (ev.key === 'Escape' || ev.keyCode === 27) {
	        $box.remove();
	        $(document).off('keydown.lightbox');
	      }
	    });
  	}

  	$('.page-content a.expandable-image').each(function(index, el) {
  		const $img = $(this).children('img');
  		const $icon = $(this).children('i');
  		const imgMargin = parseInt($img.css('margin-bottom'), 10);

	    if (imgMargin) {
	    	$icon.css('bottom', imgMargin);
	    }
  	});

  	$('.page-content').on('click', 'a.expandable-image', function (e) {
	    const href = $(this).attr('href');
	    if (!href) return;

	    // Only match image file extensions
	    if (!/\.(jpe?g|png|gif|webp|avif)$/i.test(href)) return;

	    // Restrict to uploads folder
	    if (href.indexOf('/wp-content/uploads/') === -1) return;

	    e.preventDefault();
	    openLightbox('<img src="' + href + '" alt="">');
	});

  	$('.page-content').on('click', '.view-bio a', function (e) {
	 	e.preventDefault();
		const bioHtml = $(this).parent('.view-bio').siblings('.bio-content').html() || '';
		if (bioHtml) {
			openLightbox(bioHtml, 'bio');
		}
	});

	$('.member-school').on('click', '.meet-the-head a', function (e) {
		e.preventDefault();
		const bioHtml = $(this).parent('.meet-the-head').siblings('.bio-content').html() || '';
		if (bioHtml) {
			openLightbox(bioHtml, 'bio');
		}
	});

	$('.headshot-group').each(function() {
		const $group = $(this);
		const hasPhoto = $group.find('.headshot.has-photo').length > 0;

		if (!hasPhoto) {
			$group.addClass('group-no-photos');
		}
	 });

	$('#testimonials-slider').bxSlider({
		auto: true,
		// adaptiveHeight: true,
		pause: 5000,
		pager: true,
		controls: false,
		onSlideBefore: function ($el, oldIndex, newIndex) {
			const pagerLinks = $('.testimonials-slider-wrapper .bx-pager-link');

			pagerLinks.each(function (i) {
				if (i < newIndex) {
					$(this).addClass('was-active');
				} else {
					$(this).removeClass('was-active');
				}
			});
		},
	});

	if ($('.video-wrap .placeholder').length) {

        (function waitForVimeo() {
            if (typeof Vimeo === 'undefined' || !Vimeo.Player) {
                setTimeout(waitForVimeo, 50);
                return;
            }

            $('.video-wrap .placeholder').each(function () {
                const $placeholder = $(this);
                const iframe = $placeholder.siblings('iframe')[0];
                if (!iframe) return;

                const $iframe = $(iframe);

                let player = $iframe.data('player');
                if (!player) {
                    player = new Vimeo.Player(iframe);
                    $iframe.data('player', player);
                }

                $placeholder.on('mouseenter focus', function () {
                    if ($iframe.data('preloaded')) return;
                    $iframe.data('preloaded', true);

                    player.setVolume(0);
                    player.play().then(() => {
                        const timer = setTimeout(() => {
                            if (!$iframe.data('clicked')) player.pause();
                            $iframe.removeData('preloadTimer');
                        }, 500);
                        $iframe.data('preloadTimer', timer);
                    });
                });

                $placeholder.on('click', function (event) {
                    event.preventDefault();
                    $iframe.data('clicked', true);

                    const timer = $iframe.data('preloadTimer');
                    if (timer) {
                        clearTimeout(timer);
                        $iframe.removeData('preloadTimer');
                    }

                    $(this).fadeOut(600);
                    player.setVolume(1);
                    player.play();
                });
            });

        })();

    }

	if ($(window).width() <= 980) {

		$('#burger').click(function(event) {
			event.preventDefault();
			$(this).siblings('.menu-main-container').fadeIn();
			$('body').addClass('no-scroll');
		});

		$('#close-nav').click(function(event) {
			event.preventDefault();
			$(this).closest('.menu-main-container').fadeOut();
			$('body').removeClass('no-scroll');
		});

		$('#menu-main li.menu-item-has-children > a').click(function(event) {
			event.preventDefault();

			const $link = $(this);
			const name = $.trim($link.text());
			const href = $link.attr('href');
			const $subMenu = $link.siblings('.sub-menu');
			const $subMenuList = $subMenu.find('ul');

			$subMenu.addClass('active');

			if (!$subMenuList.hasClass('overview-added')) {
				$subMenuList.addClass('overview-added');
				$subMenuList.prepend('<li><a href="'+ href +'">'+ name +' Overview</a></li>');
			}
		});

		$('#menu-main li.menu-item-has-children .sub-menu-left h6').click(function(event) {
			event.preventDefault();

			$(this).closest('.sub-menu').removeClass('active');
		});
	}
	
});